import React, { useEffect } from "react";
import { GridLoader } from "react-spinners";
import { IReportInfo } from "../../api/types/reports/IReportInfo";
import { FullLoaderStyled } from "../../components/styled/FullLoader.styled";
import { EditorMode } from "../../components/template/types/EditorMode";
import { Color } from "../../constants/colors";
import { fetchDirectoryDataForTicketGridInfo } from "../../store/directory/thunks/fetchDirectoryDataForTicketGridInfo";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { TicketGridEditor } from "./editor/TicketGridEditor";

interface Props {
  mode: EditorMode;
  source?: IReportInfo;
  onClose: () => void;
}

export const ModifyTicketGridTemplate = ({ mode, source, onClose }: Props) => {
  const dispatch = useAppDispatch();
  const data = useAppSelector((s) => s.reportData.data);

  useEffect(() => {
    if (source) dispatch(fetchDirectoryDataForTicketGridInfo(source));
  }, [source]);

  return data && data.id === source?.id ? (
    <TicketGridEditor mode={mode} source={data} onClose={onClose} />
  ) : (
    <FullLoaderStyled>
      <GridLoader color={Color.brand} />
    </FullLoaderStyled>
  );
};
